module.exports = __webpack_public_path__ + "img/innovadores-icon.b351b324.svg";